// extracted by mini-css-extract-plugin
export default {"button__wrapper":"button_button__wrapper__S-9xb","button":"button_button__go0KH","button__secondary":"button_button__secondary__4fJZ0"};